<script setup lang="ts">
import { computed } from 'vue';
import { trans } from '@tools/translation';
import { ViewType } from '@components/StickyTabs/map-constants';
import MobileViewDropdown from '@components/StickyTabs/MobileViewDropdown.vue';

const { currentView } = defineProps<{
  currentView: ViewType;
}>();

const emit = defineEmits<{(event: 'set-view', view: ViewType): void }>();

const value = computed<ViewType>(() => currentView);

const onChange = (val: string): void => {
  emit('set-view', val as ViewType);
};
</script>

<template>
  <div class="sticky-tabs !bottom-[90px]">
    <MobileViewDropdown
      :view="value"
      @change="onChange"
    />
  </div>
</template>
